import { Stack, Typography } from "@mui/material";
import SupportTabsComponent from "../../components/panel/ticket-board/ticket-tabs/TicketTabs";
import { useState } from "react";

export default function TicketPage() {
  const [ticketReload, setTicketReload] = useState<boolean>(false);

  return (
    <>
      <Stack
        width="100%"
        direction="column"
        justifyContent="start"
        alignItems="start"
        px={{ xs: "6px", md: "20px" }}
        gap="10px"
      >
        <Stack direction={"column"} width="100%">
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ md: "center", xs: "start" }}
            width="100%"
          >
            <Stack>
              <Typography
                variant="h4DemiBold"
                color={({ palette }) => palette.dominant.main}
                sx={{
                  mb: "4px",
                  mt: { xs: "0px", sm: "24px" },
                }}
              >
                پشتیبانی
              </Typography>
              <Typography
                variant="footerDemiBold"
                color={({ palette }) => palette.complement[300]}
                sx={{
                  mb: "20px",
                }}
              >
                تیکت های شما
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent={{ md: "space-between", xs: "center" }}
              width={{ xs: "100%", sm: "initial" }}
              gap="12px"
            ></Stack>
          </Stack>
        </Stack>
        <SupportTabsComponent
          ticketReload={ticketReload}
          setTicketReload={setTicketReload}
        />
      </Stack>
    </>
  );
}
